import styled from "styled-components";

import { media } from "constants/media";

export const Wrapper = styled.div`
    height: 168px;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    right: 0;
    top: 128px;
    width: 424px;
    z-index: -1;

    > span {
        border-radius: 160px;
    }

    ${media.mdUp} {
        top: 164px;
    }

    ${media.lgUp} {
        border-radius: 400px;
        height: 480px;
        left: unset;
        margin: 0;
        right: -10%;
        top: 240px;
        width: 898px;

        &::before {
            //stylelint-disable
            background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0.2) 0%,
                rgba(255, 255, 255, 0) 100%
            );
            //stylelint-enable
            border-radius: 400px;
            content: "";
            display: block;
            height: 480px;
            position: absolute;
            width: 898px;
            z-index: 1;
        }

        > span {
            border-radius: 400px;
        }
    }
`;
